<template>
  <section
    class="application-forms"
    :class="_.get(contentData, 'conf.conf[0]') == 'layout2' ? 'background' : ''"
  >
    <div class="container-2 fade-up" v-in-viewport.once>
      <h2 class="font-34" v-if="_.get(contentData, 'conf.header.title')">
        {{ _.get(contentData, "conf.header.title") }}
      </h2>

      <template
        v-for="(item, index) in _.orderBy(
          _.get(contentData, 'data.list'),
          'sort',
          'asc'
        )"
      >
        <div class="file-download" :key="index">
          <p class="font-16 title">{{ item.title }}</p>
          <div class="download-buttons">
            <!-- :class="true ? 'disabled' : ''" -->
            <div
              class="download-box"
              :class="!_.get(item, 'file_georgian[0]') ? 'disabled' : ''"
              @click="downlaodFun(_.get(item, 'file_georgian[0]'))"
            >
              <IconComponent name="download-arrow" />
              <p class="download-lang">{{ $fn.tr("Georgian") }}</p>
            </div>
            <div
              class="download-box"
              :class="!_.get(item, 'file_english[0]') ? 'disabled' : ''"
              @click="downlaodFun(_.get(item, 'file_english[0]'))"
            >
              <IconComponent name="download-arrow" />
              <p class="download-lang">{{ $fn.tr("English") }}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import IconComponent from "../IconComponent.vue";

export default {
  props: ["contentData"],

  components: {
    IconComponent
  },

  data() {
    return {};
  },
  methods: {
    downlaodFun(val) {
      window.open(_.get(val, "url"), "_blank");
    }
  }
};
</script>

<style lang="scss">
.application-forms {
  padding: 89px 0;
  h2 {
    color: var(--bonus-txt);
    width: fit-content;
    margin-bottom: 55px;
  }
  .file-download {
    background: var(--white-bg);
    border: 1px solid var(--white-txt);
    padding: 30px 60px 30px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    position: relative;
    @media (max-width: 1365px) {
      padding: 30px 20px;
    }
    @media (max-width: 1023px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 15px 20px;
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -30px;
      max-height: 25px;
      height: 100%;
      width: 2px;
      border-radius: 5px;
      background: var(--red);
      transform: translateY(-50%);
      transition: 0.4s ease-in-out;
      @media (max-width: 1023px) {
        display: none;
      }
    }
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    p {
      color: var(--bonus-txt);
    }
    .title {
      max-width: 70%;
      margin-right: 30px;
      @media (max-width: 1023px) {
        max-width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
    .download-buttons {
      display: flex;
      align-items: center;

      .download-box {
        display: flex;
        align-items: center;
        color: var(--bonus-txt);
        cursor: pointer;
        &.disabled {
          opacity: 0.3;
          pointer-events: none;
          cursor: not-allowed;
        }
        &:not(:last-child) {
          margin-right: 55px;
        }
        .download-lang {
          text-decoration: underline;
          text-decoration-color: var(--bonus-txt);
        }
        svg {
          margin-right: 10px;
        }
      }
    }
    &:hover {
      background: var(--secondary);
      &::before {
        content: "";
        max-height: 150px;
        background: var(--secondary);
        transition: 0.4s ease-in-out;
      }
      p {
        color: var(--white-txt);
      }
      .download-buttons {
        .download-box {
          .download-lang {
            text-decoration: underline;
            text-decoration-color: var(--white-txt);
          }
          svg {
            path {
              fill: var(--white-txt);
            }
          }
        }
      }
    }
  }
  &.background {
    background: var(--thirdy-tranparent);
    margin: 55px 0;
    .file-download {
      box-shadow: none;
    }
  }
}
</style>
